import { jsx as _jsx } from "react/jsx-runtime";
import { Price } from '@yonderland/andes-react';
import { useSelector } from 'react-redux';
import { usePriceProps } from '../../../hooks/usePriceProps';
import { makeGetDynamicSavingsInformation, makeGetPriceInformation, } from '../../../redux/product/selectors/ProductSelector';
export const ProductPrice = () => {
    var _a;
    const priceInformation = useSelector(makeGetPriceInformation());
    const dynamicSavingsInformation = useSelector(makeGetDynamicSavingsInformation());
    const priceProps = usePriceProps({
        priceInformation: {
            prices: (priceInformation || {}).prices,
            hasDiscount: Boolean(priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.hasDiscount),
        },
        dynamicSavingsInformation,
    });
    return ((_a = priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.prices) === null || _a === void 0 ? void 0 : _a.SELL) && !!priceProps ? (_jsx(Price, Object.assign({ testId: "product_price", size: "lg" }, priceProps))) : null;
};
